import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/35_winter_house/35_winter_house"
 * Contains 1 texture(s)
 */
export class Tablet35WinterHouseAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/35_winter_house/35_winter_house';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '35_winter_house.png'
    ] as const;
}
